import React, { useEffect, useState } from "react";
import { ReactComponent as Facebook } from "../../assets/SvgFiles/facebook.svg";
import { ReactComponent as Instagram } from "../../assets/SvgFiles/instagram.svg";
import { ReactComponent as Twitter } from "../../assets/SvgFiles/twitter.svg";
import { ReactComponent as Linkedin } from "../../assets/SvgFiles/linkedin.svg";
import { ReactComponent as Home } from "../../assets/SvgFiles/home.svg";
import { ReactComponent as SelectedHome } from "../../assets/SvgFiles/selected-home.svg";
import { ReactComponent as SelectedChat } from "../../assets/SvgFiles/selected-Chat.svg";
import { ReactComponent as SelectedSave } from "../../assets/SvgFiles/selected-saved.svg";
import { ReactComponent as SelectedProfile } from "../../assets/SvgFiles/selected-profile.svg";
import { ReactComponent as Chat } from "../../assets/SvgFiles/chat.svg";
import { ReactComponent as Save } from "../../assets/SvgFiles/save.svg";
import { ReactComponent as Profile } from "../../assets/SvgFiles/profile.svg";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";


const Footer = () => {
  const { t, i18n } = useTranslation();  // Get translation function 't' and i18n instance

  const [active, setActive] = useState("home");
  const navigate = useNavigate();
  const [language, setLanguage] = useState("en");

  const tabs = [
    { name: "home", icon: <Home />, selected: <SelectedHome />, path: "/" },
    { name: "saved", icon: <Save />, selected: <SelectedSave />, path: "/home/saved" },
    { name: "profile", icon: <Profile />, selected: <SelectedProfile />, path: "/home/profile" },
  ];


  const handleClick = (tab) => {
    setActive(tab.name);
    navigate(tab.path);
  };

  const handleSignup = () => {
    navigate("/signup", { state: { isAgent: true } });
  };

  useEffect(() => {
    const savedLanguage = localStorage.getItem("selectedLanguage") || "en";
    i18n.changeLanguage(savedLanguage);
    setLanguage(savedLanguage);
  }, []);



  return (
    <footer className="h-auto w-full text-center flex flex-col">
      {/* Large Screen Content */}
      <div className="lg:block hidden">
        <div className="md:p-24 p-3 bg-gray-50">
          <p className="text-[#F06565] font-semibold text-xl">{t('footer.noSpamPromise')}</p>
          <h2 className="text-3xl sm:text-4xl font-bold my-4">{t('footer.areYouLandowner')}</h2>
          <p className="text-gray-600 mb-6">{t('footer.discoverWays')}</p>
          <button onClick={handleSignup} className="bg-white hover:bg-gray-50 transition-all  rounded-xl px-3 py-3 md:px-8 md:py-4 text-[#F06565] font-semibold text-sm md:text-base shadow-md hover:shadow-lg transform hover:-translate-y-0.5 duration-200">
            {t("becomeAHost")}
          </button>

          <form className="flex mt-4 flex-col sm:flex-row items-center justify-center gap-4">
            <input
              type="email"
              placeholder={t('footer.enterEmail')}
              className="px-4 py-3 w-full sm:w-[350px] rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-red-400"
            />
            <button
              type="submit"
              className="bg-[#F06565] text-white px-6 py-3 rounded-md hover:bg-red-500 transition"
            >
              {t('footer.submit')}
            </button>
          </form>

          <p className="text-gray-500 text-sm mt-4">
            {t('footer.joinLandlords')}
          </p>
        </div>

        {/* White sections */}
        <div className="border-t border-gray-200 pt-10 bg-white" />

        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 text-left lg:px-24 xl:px-48 text-sm text-gray-600 mb-10 bg-white">
          <div>
            <h3 className="font-bold text-lg text-red-500">Location Ethiopia</h3>
          </div>

          <div>
            <h4 className="font-semibold mb-3 text-[#44444]">{t('footer.about')}</h4>
            <ul className="space-y-2">
              <li>{t('footer.company')}</li>
              <li>{t('footer.howItWorks')}</li>
              <li>{t('footer.contact')}</li>
              <li>{t('footer.investors')}</li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-3 text-[#44444]">{t('footer.resources')}</h4>
            <ul className="space-y-2">
              <li>{t('footer.blog')}</li>
              <li>{t('footer.guides')}</li>
              <li>{t('footer.faq')}</li>
              <li>{t('footer.helpCenter')}</li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-3 text-[#44444]">{t('footer.termsPrivacy')}</h4>
            <ul className="space-y-2">
              <li>{t('footer.trustSafety')}</li>
              <li>{t('footer.termsService')}</li>
              <li>{t('footer.privacyPolicy')}</li>
            </ul>
          </div>
        </div>

        <div className="lg:px-24 xl:px-48 flex flex-col md:flex-row justify-between items-center bg-white text-gray-400 border-t pt-6 text-sm">
          <p>{t('footer.copyright')}</p>
          <div className="flex gap-4 my-10">
            <Facebook className="cursor-pointer" />
            <Instagram className="cursor-pointer" />
            <Twitter className="cursor-pointer" />
            <Linkedin className="cursor-pointer" />
          </div>
        </div>
      </div>

      {/* Mobile Footer */}
      <div className="fixed inset-x-0 bottom-0 z-50 lg:hidden bg-gray-800 text-white h-[70px] shadow-lg px-3 pb-[env(safe-area-inset-bottom)]">
        <nav className="flex justify-evenly items-center h-full">
          {tabs.map((tab) => {
            const isActive = active === tab.name;
            return (
              <button
                key={tab.name}
                onClick={() => handleClick(tab)}
                className="flex flex-col items-center justify-center gap-1"
                aria-label={tab.name}
              >
                <span className={`w-6 h-6 flex items-center justify-center ${isActive ? "text-[#F06565]" : "text-white"}`}>
                  {isActive ? tab.selected : tab.icon}
                </span>
                <span className={`text-[12px] leading-none ${isActive ? "text-[#F06565]" : "text-white"}`}>
                  {tab.name.charAt(0).toUpperCase() + tab.name.slice(1)}
                </span>
              </button>
            );
          })}
        </nav>
      </div>


    </footer>





    // <footer className="w-full px-4 py-6 md:px-6 lg:px-8 bg-gradient-to-b from-gray-100 to-white ">
    //   <div className="">


    //   <div className="grid grid-cols-1 md:grid-cols-4 gap-10 text-left lg:px-24 xl:px-48 text-sm text-gray-600 mb-10 mt-10">
    //     <div>
    //       <h3 className="font-bold text-lg text-red-500">Ethiopia Estate</h3>
    //     </div>

    //     <div>
    //       <h4 className="font-semibold mb-3 text-black">ABOUT</h4>
    //       <ul className="space-y-2">
    //         <li>Company</li>
    //         <li>How it works</li>
    //         <li>Contact</li>
    //         <li>Investors</li>
    //       </ul>
    //     </div>

    //     <div>
    //       <h4 className="font-semibold mb-3 text-black">RESOURCES</h4>
    //       <ul className="space-y-2">
    //         <li>Blog</li>
    //         <li>Guides</li>
    //         <li>FAQ</li>
    //         <li>Help Center</li>
    //       </ul>
    //     </div>

    //     <div>
    //       <h4 className="font-semibold mb-3 text-black">TERMS & PRIVACY</h4>
    //       <ul className="space-y-2">
    //         <li>Trust & Safety</li>
    //         <li>Terms of Service</li>
    //         <li>Privacy Policy</li>
    //       </ul>
    //     </div>
    //   </div>

    //   <div className="lg:px-24 xl:px-48 flex flex-col md:flex-row justify-between items-center bg-white text-gray-400 border-t pt-6 text-sm">
    //     <p>©2025. All rights reserved</p>
    //     <div className="flex gap-4 my-10">
    //       <Facebook className="cursor-pointer" />
    //       <Instagram className="cursor-pointer" />
    //       <Twitter className="cursor-pointer" />
    //       <Linkedin className="cursor-pointer" />
    //     </div>
    //   </div>
    //   </div>
    // </footer>

  );
};

export default Footer;
